import categoryEdit from './_category_edit';

// 最大階層
const MAX_DEPTH = 8;

/**
 * カテゴリリストを表示するコンポーネント
 */
export default {
    name: 'category-list',
    template: '#category_list_template',
    data() {
        return {
            // 表示対象カテゴリデータ
            show_categories: [],
        };
    },
    props: {
        // ディスプレイモード
        displayMode: {
            type: String,
            default: 'normal',
            validator: function (value) {
                // プロパティの値は、必ずいずれかの文字列でなければならない
                return ['normal', 'link'].indexOf(value) !== -1;
            }
        },
        // 全カテゴリリスト
        categories: {
            type: Array,
            default: () => ([])
        },
        // 選択中のパスリスト
        path_config: {
            type: Array,
            default: () => ([])
        },
        // 下位カテゴリを表示しているpage_keyリスト
        show_childs: {
            type: Array,
            default: () => ([])
        },
        // 下位カテゴリが表示される指定ページキー
        page_key: {
            type: String,
            default: null
        }
    },
    components: {
        // ストアクリエイターからデータを取得するコンポーネント
        'category-edit': categoryEdit,
    },
    computed: {
        // このコンポーネント用のpath_config
        local_path_config: {
            get() {
                return this.path_config;
            },
            set(value) {
                this.$emit('update:path_config', value);
            },
        },
        // このコンポーネント用のcategories
        local_categories: {
            get() {
                return this.categories;
            },
            set(value) {
                this.$emit('update:categories', value);
            },
        },
        // このコンポーネント用のshow_childs
        local_show_childs: {
            get() {
                return this.show_childs;
            },
            set(value) {
                this.$emit('update:show_childs', value);
            },
        },
        // 表示するカテゴリ数
        showCategoriesCount: function () {
            return this.show_categories.length;
        },
        // 表示するカテゴリの階層
        depth: function () {
            if (this.showCategoriesCount) {
                return Number(this.show_categories[0].depth);
            }
            return null;
        },
        // 最大階層
        maxDepth: function () {
            return MAX_DEPTH;
        },
    },
    watch: {
        // 全カテゴリが更新された時 or 読み込み時
        local_categories: {
            handler() {
                this.setShowCategories();
                this.updateShowChilds();
            },
            immediate: true,
        },
    },
    emits: [
        'update:categories',
        'update:path_config',
        'update:show_childs',
        'selected-category',
        'clicked-delete-btn',
    ],
    methods: {
        // ディスプレイモードが通常か
        isDisplayModeNormal: function () {
            return this.displayMode === 'normal';
        },
        // ディスプレイモードがリンクか
        isDisplayModeLink: function () {
            return this.displayMode === 'link';
        },
        // 非表示カテゴリのチェックを外そうとした時のアラート
        confirmUnselectHiddenpage: async function (pageKey) {
            const before = this.local_path_config;
            // 非表示ページの以外の選択/解除だったら抜ける
            if (!this.isHiddenpage(pageKey) || !this.isSelectedHiddenpage()) {
                return;
            }
            // チェックを外さない場合、元に戻す
            if (!await swalConfirm('Magnetは「hiddenpage」カテゴリに対応していません。再選択はできませんが宜しいですか？')) {
                this.local_path_config = before;
            }
        },
        // 対象のカテゴリを表示するか否か
        isShow: function (pageKey) {
            // 非表示カテゴリでなければ表示
            if (!this.isHiddenpage(pageKey)) {
                return true;
            }
            // すでに非表示カテゴリが選択されている場合は表示
            if (this.isSelectedHiddenpage()) {
                return true;
            }
            // 非表示カテゴリが選択されていない場合は非表示
            return false;
        },
        // 非表示カテゴリが選択されているか
        isSelectedHiddenpage: function () {
            return (this.local_path_config.indexOf('hiddenpage') != -1);
        },
        // 非表示カテゴリか否か
        isHiddenpage: function (pageKey) {
            return (pageKey === 'hiddenpage');
        },
        // 下位カテゴリが表示されているか
        isShowChildCategories: function (categoryData) {
            const index = this.getShowChildIndex(categoryData.page_key);
            if (index < 0) {
                return false;
            }
            return true;
        },
        // 対象page_keyに紐付く子カテゴリを取得
        setShowCategories: function () {
            this.show_categories = this.getChildrenCategories(this.page_key);
        },
        // 子を開いた状態で子がなかった時閉じる。親から子の新規追加をキャンセルすると子が開いたまま空になる対策
        updateShowChilds: function () {
            const categories = _.cloneDeep(this.show_categories);
            let localShowChilds = _.cloneDeep(this.local_show_childs);
            for (const i in localShowChilds) {
                const pageKey = localShowChilds[i].page_key;
                const category = categories.find(category => category.page_key === pageKey);
                if (typeof category !== 'undefined' && !category.has_child) {
                    this.deleteShowChilds(category);
                }
            }
        },
        // 対象キーの子カテゴリリストを取得
        getChildrenCategories: function (pageKey = null) {
            const localCategories = _.cloneDeep(this.local_categories);
            let categories = [];
            for (const i in localCategories) {
                let category = localCategories[i];
                if (category.parent_page_key === pageKey) {
                    category.has_child = false;
                    // 名前があるものだけを想定(新規カテゴリを除く)
                    if (category.name.length != 0) {
                        const childCategories = this.getChildrenCategories(category.page_key);
                        category.has_child = childCategories.length > 0;
                        category.show_add_btn = childCategories.filter(childCategory => childCategory.page_key !== null).length > 0;
                    }
                    categories.push(category);
                }
            }
            return categories;
        },
        // 指定下位カテゴリの開閉(表示リストへデータ追加/削除)
        toggleShowChild: function(categoryData) {
            // 表示中なら非表示
            if (this.isShowChildCategories(categoryData)) {
                this.deleteShowChilds(categoryData);
            // 非表示なら表示
            } else {
                let localShowChilds = _.cloneDeep(this.local_show_childs);
                localShowChilds.push({
                    page_key: categoryData.page_key,
                    parent_page_key: categoryData.parent_page_key,
                });
                this.local_show_childs = localShowChilds;
            }
        },
        // 指定下位カテゴリを非表示にする
        deleteShowChilds: function (categoryData) {
            let localShowChilds = _.cloneDeep(this.local_show_childs);
            const index = this.getShowChildIndex(categoryData.page_key);
            if (index >= 0) {
                localShowChilds.splice(index, 1);
                this.local_show_childs = localShowChilds;
                const showParentChild = localShowChilds.find(showChild => showChild.parent_page_key === categoryData.page_key);
                if (typeof showParentChild !== 'undefined') {
                    this.$nextTick(function() {
                        this.deleteShowChilds(showParentChild);
                    });
                }
            }
        },
        // 下位カテゴリを追加する
        addChildrenCategory: function (categoryData) {

            const localCategories = _.cloneDeep(this.local_categories);
            const params = this.createNewCategoryData(categoryData.page_key, categoryData.depth, 1);

            let categories = [];
            for (const i in localCategories) {
                let category = localCategories[i];
                categories.push(category);
                if (category.page_key === categoryData.page_key) {
                    categories.push(params);
                }
            }
            this.local_categories = categories;
            this.$nextTick(function() {
                this.toggleShowChild(categoryData);
            });
        },
        // 兄弟階層へカテゴリを追加する
        addSiblingsCategory: function (categoryData) {
            const localCategories = _.cloneDeep(this.local_categories);
            const order = localCategories.filter(function(category) {
                return (category.parent_page_key === categoryData.page_key);
            }).length;
            const params = this.createNewCategoryData(categoryData.page_key, categoryData.depth, order + 1);

            let categories = [];
            for (const i in localCategories) {
                let category = localCategories[i];
                categories.push(category);
                if (category.parent_page_key === categoryData.page_key && category.order === order) {
                    categories.push(params);
                }
            }
            this.local_categories = categories;
        },
        // 表示中リストから対象のindexキーを取得する
        getShowChildIndex: function (pageKey) {
            const localShowChilds = _.cloneDeep(this.local_show_childs);
            return localShowChilds.findIndex(showChild => showChild.page_key === pageKey);
        },
        // 新規追加データ
        createNewCategoryData: function (parentPageKey, depth, order) {
            return {
                name: '',
                page_key: null,
                parent_page_key: parentPageKey,
                depth: Number(depth) + 1,
                order: order,
            };
        },
        // カテゴリ選択を通知する
        emitSeletedCategory: function (pageKey) {
            this.$emit('selected-category', pageKey);
        },
        // 削除ボタンクリックを通知する
        emitClickedDeleteBtn: function(params) {
            this.$emit('clicked-delete-btn', params);
        },
    }
};
